import { Modal, Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { LazyLoadImage } from "react-lazy-load-image-component";
import AnimationLoading from "../../../components/Animationloading";
import { convertCurrency, numberFormat } from "../../../helper";
import { S3_URL } from "../../../const";

const formatAttributes = (attributeValues = []) => {
  if (!Array.isArray(attributeValues) || attributeValues.length === 0) return "-";
  return attributeValues
    .map((attr) => {
      const name = attr?.attribute?.name || "";
      const value = attr?.value || "";
      return name ? `${name}${value ? `: ${value}` : ""}` : value;
    })
    .filter(Boolean)
    .join(", ");
};

function ProductVariantModal({
  show,
  onHide,
  variants,
  loading,
  onSelectVariant,
  parentProduct,
}) {
  const { t } = useTranslation();

  return (
    <Modal size="lg" show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>
          {/* {t("product_variant_list")} */}
          {parentProduct?.name ? `${parentProduct.name}` : ""}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading ? (
          <AnimationLoading />
        ) : variants?.length > 0 ? (
          <Table bordered responsive style={{ fontSize: 13 }}>
            <thead>
              <tr>
                <th>#</th>
                <th>ຮູບພາບ</th>
                <th>{t("product_name_tb", { defaultValue: "Product" })}</th>
                <th>{t("tb_option", { defaultValue: "Options" })}</th>
                <th>{t("qty_name_tb", { defaultValue: "Qty" })}</th>
                <th>{t("price_name_tb", { defaultValue: "Price" })}</th>
              </tr>
            </thead>
            <tbody>
              {variants.map((variant, index) => {
                const attrs = formatAttributes(variant?.attributeValues);
                const isOut = (variant?.amount ?? 0) <= 0;
                return (
                  <tr
                    key={variant?.id || index}
                    style={{ cursor: "pointer", color: isOut ? "red" : "" }}
                    onClick={() => onSelectVariant(variant)}>
                    <td>{index + 1}</td>
                    <td>
                      {((Array.isArray(variant?.image) && variant?.image?.length > 0) || (typeof variant?.image === 'string' && variant?.image)) ? (
                        <LazyLoadImage
                          src={
                            Array.isArray(variant?.image) && variant?.image?.length > 0
                              ? S3_URL + variant?.image[0]
                              : S3_URL + variant?.image
                          }
                          width="40px"
                          height="40px"
                          style={{ objectFit: "cover", borderRadius: "4px" }}
                          onError={(e) => {
                             e.target.style.display = 'none';
                             const parent = e.target.parentElement;
                             const fallback = parent.querySelector('.fallback-image-container');
                             if (fallback) fallback.style.display = 'flex';
                           }}
                        />
                      ) : null}
                      {(!variant?.image || variant?.image?.length === 0) && (
                        <div
                          style={{
                            width: 40,
                            height: 40,
                            backgroundColor: "#f3f4f6",
                            borderRadius: 4,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: 8,
                            color: "#9ca3af",
                            textAlign: "center"
                          }}
                        >
                          No Image
                        </div>
                      )}
                      <div
                        className="fallback-image-container"
                        style={{
                          display: 'none',
                          width: 40,
                          height: 40,
                          backgroundColor: "#f3f4f6",
                          borderRadius: 4,
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: 8,
                          color: "#9ca3af",
                          textAlign: "center"
                        }}
                      >
                        No Image
                      </div>
                    </td>
                    <td>{variant?.product?.name ?? parentProduct?.name ?? "-"}</td>
                    <td>{attrs}</td>
                    <td style={{ fontWeight: isOut ? "bold" : "normal" }}>
                      {numberFormat(variant?.amount ?? 0)}
                    </td>
                    <td>
                      <span style={{ marginRight: 6 }}>
                        {convertCurrency(variant?.currency)}
                      </span>
                      {numberFormat(variant?.price ?? 0)}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        ) : (
          <div style={{ textAlign: "center", padding: "2rem", color: "#6B7280" }}>
            {t("empty_name_list", { defaultValue: "No data" })}
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
}

export default ProductVariantModal;
